var _mask, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgEmptySocialNetworks = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 153,
  height: 153,
  fill: "none"
}, props), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
  id: "emptySocialNetworks_svg__a",
  width: 153,
  height: 153,
  x: 0,
  y: 0,
  "mask-type": "alpha",
  maskUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 76.5,
  cy: 76.5,
  r: 76.5,
  fill: "#F3F6F9"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#emptySocialNetworks_svg__a)"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 76.5,
  cy: 76.5,
  r: 76.5,
  fill: "#E9ECEF"
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#emptySocialNetworks_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#F8F8FD",
  d: "M43 29h165v129H43z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#emptySocialNetworks_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M43 29h165v41H43z"
})), /*#__PURE__*/React.createElement("g", {
  filter: "url(#emptySocialNetworks_svg__d)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 149,
  height: 48,
  x: 56,
  y: 81,
  fill: "#fff",
  rx: 2
})), /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 93,
  r: 5,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 93,
  r: 5,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 67,
  cy: 117,
  r: 5,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("circle", {
  cx: 79,
  cy: 117,
  r: 5,
  fill: "#E4E8F1"
}), /*#__PURE__*/React.createElement("rect", {
  width: 45,
  height: 6,
  x: 55,
  y: 40,
  fill: "#E4E8F1",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 2,
  x: 90,
  y: 89,
  fill: "#E4E8F1",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 45,
  height: 2,
  x: 90,
  y: 94,
  fill: "#E4E8F1",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 18,
  height: 2,
  x: 90,
  y: 113,
  fill: "#E4E8F1",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 45,
  height: 2,
  x: 90,
  y: 118,
  fill: "#E4E8F1",
  rx: 1
}), /*#__PURE__*/React.createElement("rect", {
  width: 136,
  height: 6,
  x: 55,
  y: 53,
  fill: "#E4E8F1",
  rx: 3
}), /*#__PURE__*/React.createElement("rect", {
  width: 72,
  height: 6,
  x: 104,
  y: 40,
  fill: "#E4E8F1",
  rx: 3
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#E4E8F1",
  d: "M56 104.5h149",
  opacity: 0.5
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "emptySocialNetworks_svg__b",
  width: 173,
  height: 137,
  x: 39,
  y: 29,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 4
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.130469 0 0 0 0 0.254849 0 0 0 0 0.695833 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "emptySocialNetworks_svg__c",
  width: 169,
  height: 45,
  x: 41,
  y: 28,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})), /*#__PURE__*/React.createElement("filter", {
  id: "emptySocialNetworks_svg__d",
  width: 153,
  height: 52,
  x: 54,
  y: 80,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 1
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow",
  result: "shape"
})))));
export { SvgEmptySocialNetworks as ReactComponent };
export default __webpack_public_path__ + "static/media/emptySocialNetworks.32c2db3d.svg";